import Vue from "vue";
import {Component} from "vue-property-decorator";

@Component
export default class RightSideNav extends Vue {
  private close(): void {
    this.$emit('close');
  }
}
